export default function Builder({
  channel,
  originUrl,
  campaign,
  content,
  medium,
  source,
}) {
  let url = "";
  if (originUrl && source && medium) {
    url = `${originUrl}?${channel ? `cr=${channel}` : ``}${
      source ? `&utm_source=${source}` : ``
    }${medium ? `&utm_medium=${medium}` : ``}${
      content ? `&utm_content=${content}` : ``
    }${campaign ? `&utm_campaign=${campaign}` : ``}
	`;
  }

  return url;
}
